
var Model = require("../types/Model");

module.exports = Model({
	name: "owncontactsettings",
	init: init,
	triggers: triggers,
	listeners: listeners,

	refresh: refresh,
	setSettings: setSettings
});

function init(){
	this._contact = null;
	this._settings = {};
	this.push({});
	this.refresh();
}

function triggers(){
	return {
		update: update,
		view: view,
		clear: clear
	};
}

function listeners(){
	return {
		"mqtt:$/contact/settings/own/updated": handle_updated,
		"connectivity:online": refresh
	};
}

function clear(){
	this._contact = null;
}

function view(contact){
	var contactId = contact.who;
	this._contact = contactId;
	this.dispatch("viewing");

	var contactSettings = this._settings[contactId] || {};
	this.push(contactSettings);

	this.emit("usermetrics:trigger:track", "view contact settings for own contact", {
		contactId
	});
}

function refresh(){
	return this.api.contacts.settings.listOwn()
		.then(setSettings.bind(this));
}

function handle_updated(setting){
	this._settings[setting._id] = setting;
}

function handle_update_success() {
	var message = "mediasettings.saved";
	this.emit("toast:trigger:show", {
		content: message,
	});
}

function handle_update_error(error) {
	console.error(error);

	var message = "atouchawaysettings.error";
	this.emit("toast:trigger:show", {
		content: message,
		style: "error"
	});
}

function setSettings(settings){
	this._settings = makeMap(settings);
}

function update(settings){
	var contact = this._contact;
	this.emit("usermetrics:trigger:track", "update contact settings for own contact", { ...settings });
	return this.api.contacts.settings.update(settings, contact)
		.then(finished.bind(this))
		.then(handle_update_success.bind(this))
		.catch(handle_update_error.bind(this));
}

function finished(){
	this.dispatch("finish");
}

function makeMap(array){
	return array.reduce(function(a, e){
		a[e._id] = e;
		return a;
	}, {});
}